import { redirect, RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { STREAMING_MENU_ICONS } from '@/router/icons'
import { ContributionPointsView } from '@/views/Admin/ContributionPoints/ContributionPointsView'
import { GeoTemplatesView } from '@/views/Admin/GeoTemplatesView'
import { ImportEventsView } from '@/views/Admin/ImportEvents/ImportEventsView'
import { TournamentDetailsView } from '@/views/Admin/ImportEvents/TournamentDetailsView'
import { TournamentsView } from '@/views/Admin/ImportEvents/TournamentsView'
import { LowLatencyHostsView } from '@/views/Admin/LowLatencyHostsView'
import PastEventsView from '@/views/Admin/PastEvents/PastEventsView'
import { PipelineCheckView } from '@/views/Admin/PipelineCheckView'
import TranscodersView from '@/views/Admin/Transcoders'
import WhitelistingView from '@/views/Admin/Whitelisting'

export const ROUTE_LABEL = {
  ADMIN: 'Admin',
  IMPORT_EVENTS: 'Import Events',
  PAST_EVENTS: 'Past Events',
  TRANSCODERS: 'Transcoders',
  WHITELISTING: 'Whitelisting',
  TOKEN_GENERATOR: 'Token Generator',
  GEO_TEMPLATES: 'Geo Templates',
  PIPELINE_CHECK: 'Pipeline Check',
  SESSION_BLOCKER: 'Session Blocker',
  LOW_LATENCY_HOSTS: 'Low Latency Hosts',
  CONTRIBUTION_POINTS: 'Contribution Points',
  LICENSES: 'Licenses'
} as const

type RouteLabel = ValueOf<typeof ROUTE_LABEL>

export const ROUTE_PATH: Record<RouteLabel, string> = {
  [ROUTE_LABEL.ADMIN]: 'admin',
  [ROUTE_LABEL.IMPORT_EVENTS]: 'import-events',
  [ROUTE_LABEL.PAST_EVENTS]: 'past-events',
  [ROUTE_LABEL.TRANSCODERS]: 'transcoders',
  [ROUTE_LABEL.WHITELISTING]: 'whitelisting',
  [ROUTE_LABEL.TOKEN_GENERATOR]: 'token-generator',
  [ROUTE_LABEL.GEO_TEMPLATES]: 'geo-template',
  [ROUTE_LABEL.PIPELINE_CHECK]: 'pipeline-check/*',
  [ROUTE_LABEL.SESSION_BLOCKER]: 'session-blocker',
  [ROUTE_LABEL.LOW_LATENCY_HOSTS]: 'low-latency-hosts',
  [ROUTE_LABEL.CONTRIBUTION_POINTS]: 'contribution-points',
  [ROUTE_LABEL.LICENSES]: 'licenses'
} as const

export const adminRoutes: RouteObject[] = [
  {
    label: ROUTE_LABEL.ADMIN,
    path: ROUTE_PATH[ROUTE_LABEL.ADMIN],
    icon: STREAMING_MENU_ICONS.ADMIN,
    platforms: [PLATFORM.DGE],
    children: [
      {
        index: true,
        platforms: [PLATFORM.DDE],
        loader: () => redirect('./import-events')
      },
      {
        label: ROUTE_LABEL.IMPORT_EVENTS,
        path: ROUTE_PATH[ROUTE_LABEL.IMPORT_EVENTS],
        element: <ImportEventsView />,
        children: [
          { index: true, element: <TournamentsView /> },
          { path: ':tournamentId', element: <TournamentDetailsView /> }
        ],
        platforms: [PLATFORM.DGE]
      },
      {
        label: 'Past Events',
        path: ROUTE_PATH[ROUTE_LABEL.PAST_EVENTS],
        element: <PastEventsView />,
        platforms: [PLATFORM.DGE]
      },
      {
        label: 'Transcoders',
        path: ROUTE_PATH[ROUTE_LABEL.TRANSCODERS],
        element: <TranscodersView />,
        platforms: [PLATFORM.DGE]
      },
      {
        label: ROUTE_LABEL.WHITELISTING,
        path: ROUTE_PATH[ROUTE_LABEL.WHITELISTING],
        element: <WhitelistingView />,
        platforms: [PLATFORM.DGE]
      },
      {
        label: 'Geo Templates',
        path: ROUTE_PATH[ROUTE_LABEL.GEO_TEMPLATES],
        element: <GeoTemplatesView />,
        platforms: [PLATFORM.DGE]
      },
      {
        label: ROUTE_LABEL.PIPELINE_CHECK,
        path: ROUTE_PATH[ROUTE_LABEL.PIPELINE_CHECK],
        element: <PipelineCheckView />,
        platforms: [PLATFORM.DGE],
        loader: async ({ params }) => params['*']
      },
      {
        label: 'Low Latency Hosts',
        path: ROUTE_PATH[ROUTE_LABEL.LOW_LATENCY_HOSTS],
        element: <LowLatencyHostsView />,
        platforms: [PLATFORM.DGE]
      },
      {
        label: ROUTE_LABEL.CONTRIBUTION_POINTS,
        path: ROUTE_PATH[ROUTE_LABEL.CONTRIBUTION_POINTS],
        element: <ContributionPointsView />,
        platforms: [PLATFORM.DGE]
      }
    ]
  }
]
